import { Link } from 'react-router-dom'
import { BASE_PATH } from '../../config/site'
import { FOOTER_TRUST_PROMISE, PERMANENT_FILE_PROMISE } from '../../data/siteCopy'
import { PrivacyArchitectureMark } from '../ui/PrivacyArchitectureMark'

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="shell site-footer__grid">
        <div>
          <a className="brand brand--footer" href={BASE_PATH}>
            <span className="brand__mark"><PrivacyArchitectureMark /></span>
            <span>StayInBrowser</span>
          </a>
          <p className="site-footer__promise">{FOOTER_TRUST_PROMISE}</p>
        </div>
        <div className="site-footer__links" aria-label="Footer navigation">
          <Link to="/spending-tracker/">Spending Tracker</Link>
          <Link to="/images/">Image tools</Link>
          <Link to="/pdf/">PDF tools</Link>
          <Link to="/developer/">Developer tools</Link>
          <Link to="/data/">Data tools</Link>
          <Link to="/qr/">QR tools</Link>
          <Link to="/text/">Text tools</Link>
          <Link to="/calculators/">Calculators</Link>
          <Link to="/device/">Device tools</Link>
          <Link to="/business/">Business tools</Link>
          <Link to="/media/">Media tools</Link>
          <Link to="/how-local-processing-works/">How local processing works</Link>
          <Link to="/blog/">Guides</Link>
          <Link to="/about/">About</Link>
          <Link to="/privacy/">Privacy</Link>
          <Link to="/contact/">Contact</Link>
          <Link to="/feedback/">Feedback</Link>
          <Link to="/changelog/">Changelog</Link>
        </div>
        <p className="site-footer__note">{PERMANENT_FILE_PROMISE}</p>
      </div>
      <div className="shell site-footer__bottom">
        <span>© {new Date().getFullYear()} StayInBrowser</span>
        <span>Built for the open web</span>
      </div>
    </footer>
  )
}
